import React from "react";
import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import {
  FooterSection,
  Title,
  Para,
  Large,
  SocialLinks,
  SocialIcon,
  Copyright,
  FooterContent,
  LogoContainer,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <FooterSection>
      <Container>
        <FooterContent>
          <Row gutter={[32, 32]}>
            {/* Company Info */}
            <Col lg={6} md={12} sm={24} xs={24}>
              <LogoContainer to="/" aria-label="homepage">
                <img src="/img/logo.png" alt="LendDisk" />
              </LogoContainer>
              <Para style={{ marginTop: "1.5rem" }}>{t("footer.description")}</Para>
              <SocialLinks>
                <SocialIcon 
                  href="https://twitter.com/lenddisk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </SocialIcon>
                <SocialIcon 
                  href="https://www.linkedin.com/company/lenddisk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </SocialIcon>
                <SocialIcon 
                  href="https://github.com/lenddisk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
                  </svg>
                </SocialIcon>
                <SocialIcon 
                  href="https://medium.com/@lenddisk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Medium"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
                  </svg>
                </SocialIcon>
              </SocialLinks>
            </Col>

            {/* Product */}
            <Col lg={4} md={6} sm={12} xs={12}>
              <Title>{t("Product")}</Title>
              <Large to="/features">{t("Features")}</Large>
              <Large to="/product">{t("Product")}</Large>
              <Large to="/pricing">{t("Pricing")}</Large>
              <Large to="/security">{t("Security")}</Large>
              <Large to="/status">{t("Status")}</Large>
            </Col>

            {/* Company */}
            <Col lg={4} md={6} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Large to="/about">{t("About")}</Large>
              <Large to="/mission">{t("Mission")}</Large>
              <Large to="/contact">{t("Contact")}</Large>
            </Col>

            {/* Resources */}
            <Col lg={5} md={6} sm={12} xs={12}>
              <Title>{t("Resources")}</Title>
              <Large to="/help">{t("Help Center")}</Large>
              <Large to="/faq">{t("FAQs")}</Large>
              <Large to="/privacy">{t("Privacy")}</Large>
              <Large to="/terms">{t("Terms")}</Large>
            </Col>

            {/* Contact */}
            <Col lg={5} md={6} sm={12} xs={12}>
              <Title>{t("Get in Touch")}</Title>
              <Para>
                <a href="mailto:support@lenddisk.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                  support@lenddisk.com
                </a>
              </Para>
              <Para style={{ marginTop: "1rem" }}>{t("footer.location")}</Para>
            </Col>
          </Row>

          <Copyright>
            <Row justify="space-between" align="middle">
              <Col lg={12} md={12} sm={24} xs={24}>
                <Para style={{ margin: 0 }}>
                  © {new Date().getFullYear()} LendDisk. {t("footer.rights")}
                </Para>
                <Para style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', opacity: 0.8 }}>
                  {t("footer.owned")} <strong>AITE Labs</strong>
                </Para>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <Para style={{ margin: 0 }}>{t("footer.tagline")}</Para>
              </Col>
            </Row>
          </Copyright>
        </FooterContent>
      </Container>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
